export default "__VITE_ASSET__CauCUxL9__"